import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../rootReducer";

export const selectOrganizationsAvailable = createSelector(
    [
        (store: RootState) => store.userProfileOrganization.organizations,
        (store: RootState) => store.userProfileOrganization.searchText,
        (store: RootState) => store.userProfileOrganization.selectedOrganizations,

    ],
    (organizations, searchText, selectedOrganizations) => organizations?.filter(
        ({ name, id }) => {

            // Filtro por nombre
            if (
                searchText
                && !name?.toLowerCase().includes(searchText?.toLowerCase().trim())
            ) {
                return false;
            }

            // Descarta organizations que ya están seleccionados o asignados
            if (selectedOrganizations.find(( { id: selectedOrganizationId }) => selectedOrganizationId === id)) {
                return false;
              }
            return true;
        })
);